// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"bde81cb5","372":"17e2d25e","443":"8265a63f","738":"01337afd","787":"94993194","856":"c839a4a5"}[chunkId] + ".chunk.js";
};